module.exports = __webpack_public_path__ + "img/left-link-banner-fanli-jp.1a951fde.jpg";